import { toDateOnlyString } from "@/lib/utils";

function toLocalYmd(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function cierreFechaYmd(fecha: unknown): string {
  if (typeof fecha === "string") {
    return toDateOnlyString(fecha) || "";
  }
  if (fecha instanceof Date && !Number.isNaN(fecha.getTime())) {
    return toLocalYmd(fecha);
  }
  return "";
}

export function sucursalIdOfCierre(cierre: {
  sucursal?: unknown;
  sucursalId?: unknown;
  sucursal_id?: unknown;
}): number | null {
  const raw = cierre.sucursalId ?? cierre.sucursal_id ?? cierre.sucursal;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/** YYYY-MM-DD + N días en calendario local (no UTC). */
export function addDaysYmd(ymd: string, days: number): string {
  const [y, m, d] = ymd.split("-").map(Number);
  const dt = new Date(y, m - 1, d + days);
  return toLocalYmd(dt);
}

/**
 * Próxima fecha de caja a crear (punta de cadena por sucursal).
 * No forzar hoy: si la última cerrada es lunes 20 y hoy es 22, la siguiente es 21.
 * Si la última sigue abierta pero es de un día anterior, avanza +1 (varios abiertos).
 * Si la última abierta es hoy (o futura), esa misma fecha (regenerar / Actualizar).
 * Sin historial → hoy.
 */
export function nextCierreOpenYmd(
  cierres: Array<{
    fecha?: unknown;
    sucursal?: unknown;
    sucursalId?: unknown;
    sucursal_id?: unknown;
    cerrado?: boolean;
  }>,
  sucursalId: number | null,
  todayYmd: string,
): string {
  let lastYmd = "";
  let lastCerrado = true;
  for (const c of cierres) {
    const ymd = cierreFechaYmd(c.fecha);
    if (!ymd) continue;
    const sid = sucursalIdOfCierre(c);
    if (sucursalId != null && sid !== sucursalId) continue;
    if (!lastYmd || ymd > lastYmd) {
      lastYmd = ymd;
      lastCerrado = Boolean(c.cerrado);
    }
  }
  if (!lastYmd) return todayYmd;
  if (!lastCerrado && lastYmd >= todayYmd) return lastYmd;
  return addDaysYmd(lastYmd, 1);
}
